import { render } from "./ArrowsClockwise.vue?vue&type=template&id=1f5f22aa"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowsClockwise.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f5f22aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f5f22aa', __exports__)) {
    api.reload('1f5f22aa', __exports__)
  }
  
  module.hot.accept("./ArrowsClockwise.vue?vue&type=template&id=1f5f22aa", () => {
    api.rerender('1f5f22aa', render)
  })

}


export default __exports__